const state = {
    appuntamento: {
        giorno: "",
        idOrario: "",
        orario: ""
    }
}

const getters = {
    getGiorno: state => {       
        return state.appuntamento.giorno ? state.appuntamento.giorno :  JSON.parse(sessionStorage.getItem("appuntamento")).giorno;
    },
    getIdOrario: state => {       
        return state.appuntamento.idOrario ? state.appuntamento.idOrario : JSON.parse(sessionStorage.getItem("appuntamento")).idOrario;
    },
    getOrario: state => {
        return state.appuntamento.orario ? state.appuntamento.orario : JSON.parse(sessionStorage.getItem("appuntamento")).orario;
    },
    getOrarioCompleto: state => {
        let appuntamento = state.appuntamento.idOrario ? state.appuntamento : JSON.parse(sessionStorage.getItem("appuntamento"));
        if(appuntamento.orario){
            return appuntamento.orario;
        }
        else{
            return "-";
        }
    },
    getGiornoCompleto: state => {  
        
        let appuntamento = state.appuntamento.idOrario ? state.appuntamento : JSON.parse(sessionStorage.getItem("appuntamento"));
        if(appuntamento.giorno){
            let d = appuntamento.giorno.split("-");
            return d[2]+"/"+d[1]+"/"+d[0];
        }
        else{
            return "-";
        }
    }
}

const mutations = {
    setGiorno(state, giorno){
        state.appuntamento.giorno = giorno
        sessionStorage.setItem("appuntamento", JSON.stringify(state.appuntamento));
    },
    setIdOrario(state, idOrario){
        state.appuntamento.idOrario = idOrario;
        sessionStorage.setItem("appuntamento", JSON.stringify(state.appuntamento));
    },
    setOrario(state, orario){
        state.appuntamento.orario = orario;
        sessionStorage.setItem("appuntamento", JSON.stringify(state.appuntamento));
    }
}

export default{
    //namespaced: true,
    state,
    getters,    
    mutations
}